import axios from 'axios';
import {SettingsContext} from "@/utilities/settings-context";
import stringify from "json-stable-stringify";
import XRegExp from "xregexp";
import {inject, provide, reactive} from "@vue/composition-api";

const crumb = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

const regex = XRegExp("url\\([\"']?(?<url>.*?)[\"']?\\)");

export interface WallpaperState {
    wallpaperClass: string;
    styleElement: Element;
    wallpapers: Array<Record<string, string>>;
    lockedWallpaper: string;
}

const stateSymbol = Symbol('wallpaper-state');
const createState = () => {
    return reactive<WallpaperState>({
        wallpaperClass: '',
        styleElement: null as unknown as Element,
        wallpapers: [],
        lockedWallpaper: localStorage.getItem('last-wallpaper') || ''
    });
};

export function useWallpaperState(){
    return inject(stateSymbol) as WallpaperState;
}
export function provideWallpaperState() {
    return provide(
        stateSymbol,
        createState()
    );
}

export function randomizeWallpaper(wallpaperStates: WallpaperState) {

    if(wallpaperStates.wallpapers.length > 0) {

        if(wallpaperStates.lockedWallpaper === '')
        {
            let skipped = JSON.parse(localStorage.getItem('wallpaper-skips') || '[]');

            let available = wallpaperStates.wallpapers.filter(w => skipped.indexOf((XRegExp.exec(stringify(w), regex) as XRegExp.ExecArray).url) === -1);

            if (available.length === 0) {

                skipped = [skipped.pop()];

                localStorage.removeItem('wallpaper-skips');

                available = wallpaperStates.wallpapers.filter(w => skipped.indexOf((XRegExp.exec(stringify(w), regex) as XRegExp.ExecArray).url) === -1);
            }

            const wallpaper = available[Math.floor(Math.random() * available.length)];

            wallpaperStates.styleElement.textContent = `.${wallpaperStates.wallpaperClass}{${Object.keys(wallpaper).reduce((css, property) => `${css}${property}:${wallpaper[property]};`, '')}}`;

            skipped.push((XRegExp.exec(stringify(wallpaper), regex) as XRegExp.ExecArray).url);

            localStorage.setItem('wallpaper-skips', stringify(skipped));
        }
        else
        {
            const wallpaper = wallpaperStates.wallpapers.find(w => (XRegExp.exec(stringify(w), regex) as XRegExp.ExecArray).url === wallpaperStates.lockedWallpaper) as Record<string, string>;

            wallpaperStates.styleElement.textContent = `.${wallpaperStates.wallpaperClass}{${Object.keys(wallpaper).reduce((css, property) => `${css}${property}:${wallpaper[property]};`, '')}}`;
        }
    }
}

export async function populateWallpapersState() {

    const wallpaperStates = useWallpaperState();

    wallpaperStates.wallpapers = await (await axios.get<Array<Record<string, string>>>(SettingsContext.getApiUrl('wallpapers'))).data;

    wallpaperStates.wallpaperClass = `wallpaper-${Array.from({length:10},() => crumb[Math.floor(Math.random() * crumb.length)]).reduce((text, char) => `${text}${char}`, '')}`;

    wallpaperStates.styleElement = document.createElement('style');

    wallpaperStates.styleElement.setAttribute('rel', 'styleSheet');

    wallpaperStates.lockedWallpaper = localStorage.getItem('last-wallpaper') || '';

    document.querySelector('head')?.appendChild(wallpaperStates.styleElement);

    document.querySelector('body')?.classList.add(wallpaperStates.wallpaperClass);

    randomizeWallpaper(wallpaperStates);
}

export function lockWallpaper(wallpaperStates: WallpaperState) {

    const lastWallpaper = (JSON.parse(localStorage.getItem('wallpaper-skips') || '[]') as Array<string>).pop() || '';

    localStorage.setItem('last-wallpaper', lastWallpaper);

    wallpaperStates.lockedWallpaper= lastWallpaper;
}

export function unlockWallpaper(wallpaperStates: WallpaperState) {

    localStorage.removeItem('last-wallpaper');

    wallpaperStates.lockedWallpaper = '';
}

// https://source.unsplash.com/ALtNa-uKy3M/2366x3200
